import { createStore } from 'vuex'
import main from './main'
import { User } from './modules/user'
import { Organizations } from './modules/organizations'
import { Cors } from './modules/cors'
import topMenu from './top-menu'

const store = createStore({
  modules: {
    main,
    user: User,
    organizations: Organizations,
    cors: Cors,
    topMenu
  }
})

export function useStore() {
  return store
}

export default store
